import { render } from "./ProductListIsland.vue?vue&type=template&id=1eafc08f"
import script from "./ProductListIsland.vue?vue&type=script&lang=js"
export * from "./ProductListIsland.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__